import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const RatingInput = (props) => {
	const { t, i18n } = useTranslation();

	const {form_component, sub_question, rating_label, index, index2} = props;

	const userData = useSelector(state => state.userData);

	const id = `q-${form_component.fieldname}-${index}-${index2}`;

	return (
		<>
		<input
			type="radio"
			id={id}
			name={`${form_component.fieldname}[${index}]`}
			value={index2}
			checked={userData && userData[form_component.fieldname][index] === index2}
		/>
		<label htmlFor={id}>
			<div className="d-flex gap-3 opt">
				<div className="x-radio"></div>
				<div className="ans">
					<p className="mb-0 d-xl-none">
						{rating_label}
					</p>
					<div className="pic w-100 ">
					</div>
				</div>
			</div>
		</label>
		</>
	);
}

export default RatingInput;